export async function startLoading(dispatch, name, asyncFn) {
  dispatch('loading/START_LOADING', name, { root: true })

  try {
    return await asyncFn()
  } catch (err) {
    console.error(`[Loading:${name}]`, err)
    throw err
  } finally {
    dispatch('loading/END_LOADING', name, { root: true })
  }
}
